import React from 'react';
import {FaChartSimple} from "react-icons/fa6";
import Button from "../../../../components/button/button.jsx";

const StorageStatusActionCellRenderer = ({node, setDetailsModal, setArchiverSelected}) => {
    const openDetails = () => {
        setDetailsModal(true);
        setArchiverSelected(node.data.archiverId);
    }

    return (
        <div className={"flex justify-center items-center gap-2 w-full h-full"}>
            <Button target={"default"} onClick={() => openDetails()}>
                <FaChartSimple />
            </Button>
        </div>
    );
};

export default StorageStatusActionCellRenderer;